// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerPropertyAddressVerificationWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { RentalManagerPropertyAddressDetailsDto } from '../..';

interface VerificationParams {
  fullAddress: string;
  propertyTypeCode?: number;
  unit?: string;
}

export const RentalManagerPropertyAddressVerificationWebApiHandler_verification_Path =
  '/api/web/v1/properties/addresses/verification';

/**
 * Validate an address
 */
export const RentalManagerPropertyAddressVerificationWebApiHandler_verification = (
  getParams: VerificationParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<VerificationParams, never, RentalManagerPropertyAddressDetailsDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyAddressVerificationWebApiHandler_verification_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
